import packageInfo from '../../package.json';

export const environment = {
  production: false,
  testing: true,
  env: 'testing',
  appVersion: packageInfo.version,
  appUrl: 'https://dev.mes.performolabs.in',
  apiUrl: 'https://devmesapi.performolabs.in',
  wsUrl: 'wss://devmesapi.performolabs.in',
  cdnUrl:'https://mes-bucket.sgp1.digitaloceanspaces.com',
  upiId:"your-upi-id@bank",
  upiName:"Performo Labs",
  upiCurrency:"INR",
  environment: "dev",
};
